
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/age/[ageGroup]/[category]",
      function () {
        return require("private-next-pages/age/[ageGroup]/[category]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/age/[ageGroup]/[category]"])
      });
    }
  